'use client'

import Image from 'next/image'

// 4 avantages membres empilés verticalement, plein largeur.
// Chaque image est une composition complète (titre + description + visuel intégrés)
// donc pas d'overlay : les images parlent d'elles-mêmes.
// Sur mobile (<768px), on affiche une version dédiée (mobileImage) — l'image
// desktop reste inchangée.
const ITEMS = [
  {
    title: 'Accès prioritaire aux événements privés',
    image: '/demo/placeholder.svg',
    mobileImage: '/demo/placeholder.svg',
  },
  {
    title: 'Réseau business & culturel qualifié',
    image: '/demo/placeholder.svg',
    mobileImage: '/demo/placeholder.svg',
  },
  {
    title: 'Expériences exclusives',
    image: '/demo/placeholder.svg',
    mobileImage: '/demo/placeholder.svg',
  },
  {
    title: 'Rencontres en comitÃ© restreint',
    image: '/demo/placeholder.svg',
    mobileImage: '/demo/placeholder.svg',
  },
]

export default function AvantagesStack() {
  return (
    <section
      className="bg-brand-cream"
      style={{ paddingTop: 'clamp(48px, 8vw, 100px)', paddingBottom: 'clamp(48px, 8vw, 100px)' }}
    >
      <div className="max-w-[1100px] mx-auto px-4 md:px-8">
        <h2
          className="italic text-center"
          style={{
            fontFamily: 'var(--font-heading, inherit)',
            fontSize: 'clamp(1.5rem, 0.95rem + 2.4vw, 3.5rem)',
            fontWeight: 400,
            lineHeight: '125%',
            color: '#021734',
            marginBottom: 'clamp(40px, 5vw, 64px)',
          }}
        >
          Les avantages membres
        </h2>
      </div>

      <div className="max-w-[1100px] mx-auto px-4 md:px-8 flex flex-col gap-6 md:gap-8">
        {ITEMS.map((item) => (
          <div
            key={item.title}
            className="overflow-hidden cursor-default"
            style={{ transition: 'transform 0.5s ease' }}
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.012)' }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)' }}
          >
            <Image
              src={item.mobileImage}
              alt={item.title}
              width={900}
              height={1600}
              sizes="100vw"
              className="w-full h-auto block md:hidden"
            />
            <Image
              src={item.image}
              alt={item.title}
              width={1600}
              height={900}
              sizes="(max-width: 768px) 100vw, 1100px"
              className="w-full h-auto hidden md:block"
            />
          </div>
        ))}
      </div>
    </section>
  )
}
